import { EmissionScheduleRouteParams } from './types'

export type EmissionScheduleParams = EmissionScheduleRouteParams & { vooh?: boolean }

const READ_ONLY_ROUTE = 'ro'
const emissionScheduleRoute = ({
  campaignId,
  creationId,
  vooh,
  readOnly,
}: EmissionScheduleParams): string =>
  vooh
    ? `/vooh-campaign/${campaignId}/creation/${creationId}/emission-schedule${
        readOnly ? '/ro' : ''
      }`
    : `/campaign/${campaignId}/creation/${creationId}/emission-schedule`

const Routes = {
  ANY: '*',
  NOT_FOUND: '/404',
  ROOT: '/',
  HOME: '/home',
  REPORT: '/report',
  BROADSIGN: '/broadsign',
  INVENTORY: '/inventory',
  BUNDLES: '/bundles',
  FEATURES: '/features',
  AI_CREATION_UPLOAD: '/ai-creation-upload',
  EMISSION_PLAN: (uuid: string): string => `/emission-plan/${uuid}`,

  SIGN: {
    SIGN_IN: '/sign-in',
    REMIND_PASSWORD: '/remind-password',
    RESET_PASSWORD: '/passwords/reset',
    ACCEPT_INVITATION: '/accept-invitation',
  },

  CAMPAIGNS: {
    ALL: '/campaigns',
    COMPARE: '/campaigns/compare',
    COMPARE_PUBLIC: '/campaigns/compare-public',
    NEW: '/campaign/new',
    EDIT: (id: string, hash?: string): string => `/campaign/${id}/edit${hash ? '#' + hash : ''}`,
    ONE: (id: string): string => `/campaign/${id}`,
    ONE_PUBLIC: (uuid: string): string => `/campaign-public/${uuid}`,
    ACCEPTANCE_FIELDS: (id: string): string => `/campaign/${id}/acceptance-fields`,
    EMISSION_SCHEDULE: (args: EmissionScheduleParams) => emissionScheduleRoute(args),
    EMISSION_SCHEDULE_RO: (args: EmissionScheduleRouteParams) =>
      `${emissionScheduleRoute(args)}/${READ_ONLY_ROUTE}`,
    EMISSION_SCHEDULE_PUBLIC: ({ campaignUuid, creationUuid }: EmissionScheduleParams): string =>
      `/campaign-public/${campaignUuid}/creation-public/${creationUuid}/emission-schedule`,
  },

  VOOH_CAMPAIGNS: {
    ALL: '/vooh-campaigns',
    NEW: '/vooh-campaign/new',
    EDIT: (id: string, hash?: string): string =>
      `/vooh-campaign/${id}/edit${hash ? '#' + hash : ''}`,
    ONE: (id: string): string => `/vooh-campaign/${id}`,
    ONE_PUBLIC: (uuid: string): string => `/vooh-campaign-public/${uuid}`,
    EMISSION_SCHEDULE_ROUTE: (args: EmissionScheduleRouteParams) =>
      `${emissionScheduleRoute(args)}/${READ_ONLY_ROUTE}`,
    EMISSION_SCHEDULE_PUBLIC: ({ campaignUuid, creationUuid }: EmissionScheduleParams): string =>
      `/vooh-campaign-public/${campaignUuid}/creation-public/${creationUuid}/emission-schedule`,
  },

  AGENCIES: {
    ALL: '/agencies',
    NEW: '/agency/new',
    EDIT: (id: string): string => `/agency/${id}/edit`,
    DISPOSITIONS: (id: string): string => `/agency/${id}/dispositions`,
  },

  USERS: {
    ALL: '/users',
    INVITE: '/user/invite',
    EDIT: (id: string): string => `/user/${id}/edit`,
    SETTINGS: '/user/settings',
  },
  ROLES: {
    ALL: '/roles',
    NEW: '/roles/new',
    EDIT: (id: string): string => `/roles/${id}/edit`,
  },
  PRICE_LISTS: {
    ALL: '/price-lists',
    NEW: '/price-lists/new',
    EDIT: (id: string): string => `/price-lists/${id}/edit`,
  },
}

export default Routes
